import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLifts, addLift, deleteLift } from "../firebase/firestore";
import "../styles/pages.css";

const Log = ({ lifts, setLifts, showForm, setShowForm }) => {
  const [formData, setFormData] = useState({
    date: "",
    muscleGroup: "",
    completed: false,
    notes: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchLifts = async () => {
      try {
        const data = await getLifts();
        setLifts(data);
      } catch (error) {
        console.error("Error fetching lifts:", error);
      }
    };

    fetchLifts();
  }, [setLifts]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const liftId = await addLift(formData);
      setLifts((prev) => [...prev, { id: liftId, ...formData }]);
      setShowForm(false);
      setFormData({ date: "", muscleGroup: "", completed: false, notes: "" });
    } catch (error) {
      console.error("Error adding lift:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this lift?")) {
      try {
        await deleteLift(id); // Delete from Firestore
        setLifts((prev) => prev.filter((lift) => lift.id !== id)); // Remove locally
      } catch (error) {
        console.error("Error deleting lift:", error);
      }
    }
  };

  return (
    <div className="log-container">
      <h1 className="page-title">Log</h1>
      
      {showForm && (
        <form onSubmit={handleSubmit} className="add-lift-form">
          <label>
            Date:
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              required
            />
          </label>

          <label>
            Muscle Group:
            <select
              name="muscleGroup"
              value={formData.muscleGroup}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Muscle Group</option>
              <option value="Push">Push</option>
              <option value="Pull">Pull</option>
              <option value="Core">Core</option>
              <option value="Legs">Legs</option>
              <option value="Full Body">Full Body</option>
            </select>
          </label>

          <label>
            Completed:
            <input
              type="checkbox"
              name="completed"
              checked={formData.completed}
              onChange={handleInputChange}
            />
          </label>

          <label>
            Notes:
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              placeholder="Optional notes"
            />
          </label>

          <button type="submit" className="submit-button">
            Save Lift
          </button>
          <button
            type="button"
            onClick={() => setShowForm(false)}
            className="cancel-button"
          >
            Cancel
          </button>
        </form>
      )}

<ul>
  {lifts
    .slice() // Create a shallow copy to avoid mutating the original array
    .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort by date (newest to oldest)
    .map((lift) => (
      <li
        key={lift.id}
        className="lift-log-container"
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >
        <div
          className="lift-content"
          onClick={() => navigate(`/lift/${lift.id}`)}
          style={{ flex: 1, cursor: "pointer" }}
        >
          {(() => {
            const localDate = new Date(lift.date + "T00:00:00");
            const formattedDate = localDate.toLocaleDateString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "numeric",
              day: "numeric",
            });
            const formattedWithoutComma = formattedDate.replace(", ", " ");
            const [weekday, rest] = formattedWithoutComma.split(" ", 2);
            return (
              <>
                <strong>{weekday}</strong> {rest}
              </>
            );
          })()}{" "}
          | {lift.muscleGroup}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevent the navigation event when clicking delete
            handleDelete(lift.id);
          }}
          className="delete-button"
        >
          Delete
        </button>
      </li>
    ))}
</ul>

      <button onClick={() => setShowForm(true)} className="add-lift-button">
        Add Lift
      </button>
    </div>
  );
};

export default Log;
